"use strict";
//
// Copyright © 2025 Hardcore Engineering Inc.
// Copyright © 2026 Intabia Fusion.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureAnalyticsProviders = configureAnalyticsProviders;
const analytics_1 = require("@hcengineering/analytics");
const analyticsCollector_1 = require("./analyticsCollector");
const yandexMetrika_1 = require("./yandexMetrika");
__exportStar(require("./analyticsCollector"), exports);
__exportStar(require("./utils"), exports);
function configureAnalyticsProviders(config) {
    const providers = [new analyticsCollector_1.AnalyticsCollectorProvider(), new yandexMetrika_1.YandexMetrikaProvider()];
    for (const provider of providers) {
        analytics_1.Analytics.init(provider, config);
    }
}
//# sourceMappingURL=configure.js.map